var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('h3',{staticClass:"checkout-heading"},[_vm._v("Feedback Submitted")]),_c('p',[_vm._v("We'll be in touch shortly!")])])])
}]

export { render, staticRenderFns }